import React, { forwardRef } from 'react';
import Icon from '../Icon';
import { SpinnerWrap } from './atoms';
const Spinner = forwardRef((props, ref) => {
    const { $size, $color = 'primaryFill', ...otherProps } = props;
    return (React.createElement(SpinnerWrap, { ...otherProps, "$size": $size, ref: ref },
        React.createElement(Icon, { icon: 'ic_loading_spinner', "$size": $size, "$color": $color })));
});
export default Spinner;
